import { Authors } from "~/components/blog/authors";
import { Date } from "~/components/blog/date";
import { HorizontalSeparator } from "~/components/blog/horizontal-separator";
import { Share } from "~/components/blog/share";
import type { Author } from "~/lib/authors";

type Props = Readonly<{
  authors: readonly Author[];
  date: string;
  readingTime: string;
  timeOverride?: number;
  title: string;
  url: string;
}>;

export function PostHeader({
  authors,
  date,
  readingTime,
  timeOverride,
  title,
  url,
}: Props): JSX.Element {
  return (
    <div className="prose dark:prose-invert max-w-full">
      <div className="flex flex-col gap-8">
        <div className="flex flex-row gap-x-6 items-center">
          <Date dateString={date} />
          <HorizontalSeparator />
          <div className="whitespace-nowrap">
            {timeOverride ? `${timeOverride} min read` : readingTime}
          </div>
        </div>
        <Authors authors={authors} />
        <Share title={title} url={url} />
      </div>
    </div>
  );
}
